import React from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import WebView from 'react-native-webview';
import {ShouldStartLoadRequest} from 'react-native-webview/lib/WebViewTypes';

import ContentView from '../../components/ui-controls/layout/ContentView';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';

function PromotionIFrameLinkScreen({
  route,
  navigation,
}: RouteNavigatorScreenProps<AppRoute.PROMOTION_IFRAME>) {
  const params = route.params.iFrameLinkParams || '';
  const url = route.params.url;
  const uri = params ? `${url}?${params}` : url;

  const handleShouldStartLoadWithRequest = (request: ShouldStartLoadRequest) => {
    // Hack: Bundy Power Plays: Deep links to this own app are not working on the WebView
    if (request.url.includes('/brands/Bundaberg')) {
      // TODO: XXX FIX!!!!
      navigation.navigate(AppRoute.BRAND, {brand: 'Bundaberg'});
      return false; // Prevent the WebView from loading the URL
    }
    return true; // Allow the WebView to load other URLs
  };

  return (
    <ContentView testID="promotion-detail-screen-iframe">
      <ScrollView contentContainerStyle={styles.main}>
        <WebView
          testID="promotion-detail-screen-iframe-webview"
          source={{
            uri,
          }}
          scrollEnabled={true}
          cacheEnabled={false}
          startInLoadingState={true}
          onShouldStartLoadWithRequest={handleShouldStartLoadWithRequest}
        />
      </ScrollView>
    </ContentView>
  );
}

export default PromotionIFrameLinkScreen;

const styles = StyleSheet.create({
  main: {
    flex: 1,
  },
  webIFrame: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    border: 0,
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '10px',
  },
});
